import type { ReactNode } from 'react';
import { InlineStack, Panel, PanelSection, Text } from '@customerio/pluma-components/react';

type BillingPeriodCardProps = {
  /** The period name, e.g. "Billing period". Left out to show the aside alone. */
  label?: string;
  /** The period range, e.g. "August 7 – August 31, 2026", or a stand-in when no dates are known. */
  range?: string;
  /** The right side: the day count and charge on Overview, the approximate-figures note on Usage. */
  aside?: ReactNode;
};

/**
 * The billing period, above the cards it frames. Each tab fills the right side through the aside. A
 * tab that states no period, such as Usage for a pay-as-you-go plan, passes the aside alone.
 */
export function BillingPeriodCard({ label, range, aside }: BillingPeriodCardProps) {
  const showsPeriod = label != null || range != null;

  return (
    <Panel data-test-billing-period-card>
      <PanelSection>
        <InlineStack alignInline="space-between" alignBlock="center" gap="200" wrap={true}>
          {showsPeriod ? (
            <InlineStack alignBlock="baseline" gap="075">
              {label != null ? (
                <Text size="sm" weight="semibold">
                  {label}
                </Text>
              ) : null}
              {range != null ? (
                <Text size="sm" data-test-billing-period-range>
                  {range}
                </Text>
              ) : null}
            </InlineStack>
          ) : null}
          {aside}
        </InlineStack>
      </PanelSection>
    </Panel>
  );
}
